<div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
  <div class="text-muted small">
    Showing
    <strong>{{ startIndex + 1 }}</strong>–<strong>{{ endIndex }}</strong>
    of <strong>{{ totalItems }}</strong>
  </div>

  <div class="d-flex align-items-center gap-2">
    <div class="d-flex align-items-center gap-1">
      <span class="small text-muted">Rows per page:</span>
      <div class="rows-select-wrapper">
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
          @for(s of pageSizeOptions; track $index){
          <option [ngValue]="s">{{ s }}</option>
          }
        </select>
        <span class="rows-select-divider"></span>
        <span class="rows-select-chevron">
          <span class="rows-select-chevron">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6">
              <path fill="#6b7280" d="M0 0l5 6 5-6z" />
            </svg>   
          </span>
        </span>
      </div>
    </div>

    <nav>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" [class.disabled]="page === 1">
          <a class="page-link" role="button" (click)="goToPage(1)">&laquo;</a>
        </li>
        <li class="page-item" [class.disabled]="page === 1">
          <a class="page-link" role="button" (click)="goToPage(page - 1)">&lsaquo;</a>
        </li>
        <li class="page-item disabled">
          <span class="page-link bg-light">Page {{ page }} of {{ totalPages }}</span>
        </li>
        <li class="page-item" [class.disabled]="page === totalPages">
          <a class="page-link" role="button" (click)="goToPage(page + 1)">&rsaquo;</a>
        </li>
        <li class="page-item" [class.disabled]="page === totalPages">
          <a class="page-link" role="button" (click)="goToPage(totalPages)">&raquo;</a>
        </li>
      </ul>
    </nav>
  </div>
</div>